import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { InputComponent } from '../input/input.component';

@Component({
  selector: 'app-message-input',
  templateUrl: './message-input.component.html',
  styleUrls: ['./message-input.component.scss']
})
export class MessageInputComponent implements OnInit {

  public value: string = '';
  public isInvalid: boolean = false;
  public emptyField = false;

  @ViewChild('input') input: InputComponent;

  @Input() disabled: boolean = false;
  @Input() invalid: boolean = false;
  @Input() showError: boolean = true;
  @Input() placeholder: string = '';
  @Input() formGroup: FormGroup;
  @Input() fieldName: string;

  @Input() replyToLabel: string;
  @Input() replyToId: string;

  @Output() onSend: EventEmitter<string> = new EventEmitter();
  @Output() onReplyCancel: EventEmitter<void> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
    this.emptyField = !this.value?.trim().length
  }

  public sendMessage() {
    if (!this.disabled && !this.emptyField && !this.isInvalid) {
      this.onSend.emit(this.value);
      this.value = '';
    }
  }

  public checkErrors() {
    this.emptyField = !this.value?.trim().length
  }

  public focus() {
    this.input?.focus();
  }
}
